/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CircularProgress } from "@mui/material";

const DocumentUploadStatus = ({ isUploading }) => {
    return (
        <div className="replace-img-upload-status">
            <span className="upload-text">
                {isUploading ? (
                    <>
                        <CircularProgress size="22px" color="secondary" style={{ marginRight: "8px", marginBottom: "-4px" }} />
                        <span>Your file is uploading...</span>
                    </>
                ) : (
                    "The upload has not started."
                )}
            </span>
        </div>
    );
};

export { DocumentUploadStatus };
